import { createPermission } from '@backstage/plugin-permission-common';

/**
 * Grants access to triage (read and update) feedback for every doc in DevHub,
 * regardless of the owning team. The DevHub permission policy grants it to the
 * configured Platform Engineering group (`docFeedback.platformEngineeringGroup`).
 *
 * Owners of a doc can always triage the feedback for their own docs, and
 * submitters can always read their own feedback; those checks are done by the
 * backend based on the user's ownership entity refs.
 *
 * @public
 */
export const docFeedbackAdminPermission = createPermission({
  name: 'doc-feedback.admin',
  attributes: { action: 'update' },
});

/**
 * All permissions exposed by the doc feedback plugin.
 *
 * @public
 */
export const docFeedbackPermissions = [docFeedbackAdminPermission];
